import { createThemedUseStyles } from "theme";

export default createThemedUseStyles((theme) => ({
  root: {},
  displayValueText: {
    paddingLeft: "5px"
  }
}));
